import { convertFileSrc, invoke } from '@tauri-apps/api/core'
import { listen } from '@tauri-apps/api/event'
import { appDataDir } from '@tauri-apps/api/path'
import {
  BaseDirectory,
  exists,
  mkdir,
  readTextFile,
  stat,
  writeTextFile,
} from '@tauri-apps/plugin-fs'
import { isDesktop } from './helpers'

let appDataDirectory = ''
if (isDesktop) {
  appDataDir().then(dir => {
    appDataDirectory = dir
    console.info('app data directory: ', appDataDirectory)
  })
}

export type DownloadProgressCallback = (receivedBytes: number, totalBytes: number) => void

interface FileProgress {
  path: string
  total_bytes: number
  transferred_bytes: number
  percentage: number
}

export async function listenToFileSave(onData: (data: FileProgress) => void) {
  return listen('DOWNLOAD_PROGRESS', e => {
    const data = e.payload as FileProgress
    onData(data)
  })
}

export async function saveFile(url: string, path: string): Promise<null> {
  const fullPath = `${appDataDirectory}/${path}`
  return invoke('download_file', { url, path: fullPath })
}

export async function readFile(filePath: string) {
  return readTextFile(filePath, { baseDir: BaseDirectory.AppData })
}

export async function writeFile(filePath: string, contents: string) {
  return writeTextFile(filePath, contents, { baseDir: BaseDirectory.AppData })
}

export async function ensureDirectoryExists(path: string) {
  return mkdir(path, { baseDir: BaseDirectory.AppData, recursive: true })
}

export function fileMeta(filePath: string) {
  return stat(filePath, { baseDir: BaseDirectory.AppData })
}

export function fileExists(filePath: string) {
  return exists(filePath, { baseDir: BaseDirectory.AppData })
}

export function makeFileSrc(filePath: string) {
  return convertFileSrc(`${appDataDirectory}/${filePath}`)
}
